import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormControl, IconButton, InputLabel, MenuItem, Select as MuiSelect, TextField as MuiTextField, Tooltip } from '@mui/material';
import { PartnerUserTagTypesSelectMenu } from 'pages/admin-dashboard/groups/PartnerUserTagTypesSelectMenu';
import React from 'react';
import styled from 'styled-components';

const FormGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const StyledFormControl = styled(FormControl)`
  min-width: 120px;
  flex-shrink: 0;
`;

const RemoveButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

interface PartnerUserTagType {
  id: string;
  label: string;
}

export interface Rule {
  id: string;
  tagTypeId: string;
  tagTypeLabel: string;
  operator: '=' | '!=';
  value: string;
}

export const RuleEditor: React.FC<{
  rule: Rule;
  partnerUserTagTypes: PartnerUserTagType[];
  onRuleChange: (id: string, updatedFields: Partial<Rule>) => void;
  onRemoveRule: (id: string) => void;
}> = ({ rule, partnerUserTagTypes, onRuleChange, onRemoveRule }) => {
  return (
    <FormGroup>
      <PartnerUserTagTypesSelectMenu
        value={rule.tagTypeId || ''}
        onSelect={(tagTypeId) => {
          const tagType = partnerUserTagTypes.find((tt) => tt.id === tagTypeId);
          if (tagType) {
            onRuleChange(rule.id, { tagTypeId: tagType.id, tagTypeLabel: tagType.label });
          } else {
            onRuleChange(rule.id, { tagTypeId: '', tagTypeLabel: '' });
          }
        }}
      />

      <StyledFormControl variant="outlined" size="small">
        <InputLabel color="secondary">Operator</InputLabel>
        <MuiSelect
          label="Operator"
          value={rule.operator}
          onChange={(e) => onRuleChange(rule.id, { operator: e.target.value as '=' | '!=' })}
          color="secondary"
          size="small"
          style={{ minWidth: '75px' }}
        >
          <MenuItem value="=">is</MenuItem>
          <MenuItem value="!=">is not</MenuItem>
        </MuiSelect>
      </StyledFormControl>

      <MuiTextField
        variant="outlined"
        size="small"
        color="secondary"
        value={rule.value}
        onChange={(e) => onRuleChange(rule.id, { value: e.target.value })}
        placeholder="Value"
        fullWidth
      />

      <RemoveButtonWrapper>
        <Tooltip title="Remove rule">
          <IconButton
            onClick={() => onRemoveRule(rule.id)}
            color="error"
            size="small"
          >
            <FontAwesomeIcon icon={faTrash} />
          </IconButton>
        </Tooltip>
      </RemoveButtonWrapper>
    </FormGroup>
  );
};
